/* <ship-day>: the day an order placed now leaves the warehouse, as one word
   ("Today", "Tomorrow", or a weekday), for the "Ships Today" line under the
   cart's checkout button (snippets/ships-risk-free.liquid).

   Same rule as the sticky bar (sticky-add-to-cart-v2.js), which sits on screen
   with it: a 5pm ET same-day cutoff, and no shipping on Saturday or Sunday, so
   Friday after the cutoff and the weekend roll to Monday.

   A custom element so it fills itself in again whenever the cart drawer
   swaps its markup, which a script inside that markup would not; it also
   re-checks every minute so an open cart turns over at 5pm. */
const SHIP_DAY_CUTOFF_HOUR_ET = 17;
const SHIP_DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

function shipDayLabel() {
  // A Date whose local fields read as the current wall-clock time in ET.
  const et = new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));
  const cutoff = new Date(et);
  cutoff.setHours(SHIP_DAY_CUTOFF_HOUR_ET, 0, 0, 0);

  const ship = new Date(et);
  if (et >= cutoff) ship.setDate(ship.getDate() + 1);
  while (ship.getDay() === 0 || ship.getDay() === 6) ship.setDate(ship.getDate() + 1);

  const tomorrow = new Date(et);
  tomorrow.setDate(tomorrow.getDate() + 1);
  if (ship.toDateString() === et.toDateString()) return "Today";
  if (ship.toDateString() === tomorrow.toDateString()) return "Tomorrow";
  return SHIP_DAY_NAMES[ship.getDay()];
}

class ShipDay extends HTMLElement {
  connectedCallback() {
    this.update();
    this.timer = setInterval(() => this.update(), 60000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  update() {
    const label = shipDayLabel();
    if (this.textContent !== label) this.textContent = label;
  }
}

if (!customElements.get("ship-day")) customElements.define("ship-day", ShipDay);
